import { Component, OnInit } from '@angular/core';

import { ModalService } from '../../shared/modules/modal';
import {
  ClosableModalWithErrorResponseModel
} from './../../shared/components/base/closable-modal-with-error-response-model';
import {
  FunctionalAnalysesService,
  NotificationService,
  UtilsService,
  NumberFormatService
} from './../../shared/services';

import {
  ProvideTransactionFxaDetailsModalPayload,
  FunctionalAnalysesData,
  FunctionalAnalysisDataPayload,
  FunctionalAnalysesImportanceEnum,
  FunctionalAnalysesDataErrorResponse,
  FunctionalAnalysisObjectTypeEnum
} from '../../shared/models';
import { TinyTextEditor, TranslationConstants } from '../../shared/constants';

@Component({
  selector: 'provide-transaction-fxa-details-modal',
  templateUrl: './provide-transaction-fxa-details-modal.component.html',
})
export class ProvideTransactionFxaDetailsModalComponent
  extends ClosableModalWithErrorResponseModel<FunctionalAnalysesDataErrorResponse> implements OnInit {
  functionalAnalysisData = new FunctionalAnalysesData();
  data: ProvideTransactionFxaDetailsModalPayload;

  tinyInit = TinyTextEditor.INIT;

  importanceList: string[] = [];
  selectedImportance: string;

  numbers: number[];

  constructor(
    protected notificationService: NotificationService,
    protected modalService: ModalService,
    private _functionalAnalysesService: FunctionalAnalysesService,
    private _utilsService: UtilsService,
    private _numberFormatService: NumberFormatService
  ) {
    super(notificationService, modalService);

    this.validationErrors = new FunctionalAnalysesDataErrorResponse();
    this.confirmationModalTitle = TranslationConstants.FUNCTIONAL_ANALYSES_CLOSE_CHARACTERISTIC_CONFIRM;

    const numbers = [];
    for (let index = 0; index < 101; index += 5) {
      numbers.push(index);
    }
    this.numbers = numbers;
  }

  ngOnInit(): void {
    this.importanceList = this.getImportanceEnumValues();
    this.getFunctionalAnalysisData();
    this.listenForErrorMessages();
  }

  save(): void {
    if (this.isSaveDisabled) {
      return;
    }

    this.isSaveDisabled = true;

    this.resetErrors();
    const payload = this.getPayloadForSaving();
    this._functionalAnalysesService
      .updateCharacteristic(this.data.characteristicId, this.data.type, payload).subscribe(() => {
        this.success();
        this.closeAllModals();
      });
  }

  getObjectIdentifierKey(): string {
    return this._utilsService.getFunctionalAnalysisIdentifierTranslationKey(this.data.type);
  }

  getFormated(num, maxFractionDigits = 1): string {
    return this._numberFormatService.getFormatedNumber(num, maxFractionDigits);
  }

  private getFunctionalAnalysisData(): void {
    this._functionalAnalysesService
      .getCharacteristic(this.data.characteristicId, this.data.type).subscribe(({ data }) => {
        this.functionalAnalysisData = data;
        this.selectedImportance = FunctionalAnalysesImportanceEnum[this.functionalAnalysisData.importance];
      });
  }

  private getImportanceEnumValues(): string[] {
    const enumValues = Object.values(FunctionalAnalysesImportanceEnum) as string[];
    return enumValues.filter(key => !isNaN(Number(FunctionalAnalysesImportanceEnum[key])));
  }

  private getPayloadForSaving(): FunctionalAnalysisDataPayload {
    const payload = new FunctionalAnalysisDataPayload();
    payload.discussion = this.functionalAnalysisData.discussion || '';
    if (this.data.type === FunctionalAnalysisObjectTypeEnum.Pba) {
      payload.testedPartyContribution = this.functionalAnalysisData.testedPartyContribution;
      payload.otherParticipantContribution = this.functionalAnalysisData.otherParticipantContribution;
    } else {
      payload.importance = +FunctionalAnalysesImportanceEnum[this.selectedImportance];
      payload.srcContribution = this.functionalAnalysisData.srcContribution;
      payload.destContribution = this.functionalAnalysisData.destContribution;
    }

    return payload;
  }
}
